import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getCountryShortName } from '@shared/selectors';
import getCartTaxes from '@core/reducers/cart/selectors/getCartTaxes';
import Taxes from './Taxes';

const mapStateToProps = createStructuredSelector({
  country: getCountryShortName,
  taxes: getCartTaxes,
});

export default connect(mapStateToProps)(Taxes);
